"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetSliderState = void 0;
const createGetMoveState_1 = require("./createGetMoveState");
function createGetSliderState(count, width) {
    const getMove = (0, createGetMoveState_1.createGetMoveState)(count);
    return (s, i, mx = 0) => {
        const { dir, targetIndex } = getMove(s, mx);
        const isCurrentSlide = i === s.curr;
        const isPrevSlide = !isCurrentSlide && i === s.prev;
        const isTargetSlide = i === targetIndex;
        const isActive = [s.prev, s.curr].includes(i) || isTargetSlide;
        return {
            i,
            targetIndex,
            dir,
            isPrevSlide,
            isCurrentSlide,
            isTargetSlide,
            isActive,
            baseX: isTargetSlide
                ? dir * width
                : isPrevSlide
                    ? -dir * width
                    : (i - s.curr) * width,
        };
    };
}
exports.createGetSliderState = createGetSliderState;
//# sourceMappingURL=createGetSliderState.js.map